import HttpClient from 'src/features/http';
import {
  BannersResponse,
  BannersServiceInterface,
} from './bannersService.types';
import { inject, injectable } from 'inversify';
import { backendUrl } from 'src/config';

@injectable()
class BannersService implements BannersServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  async getAll() {
    return await this.client
      .getClient()
      .get<BannersResponse>('/stores/banners/', { baseURL: backendUrl });
  }
}

export default BannersService;
